import React, { useState } from 'react';
import { Search, Printer, Award } from 'lucide-react';

const ExamResult = () => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Exam Result</h1>
        <p className="text-sm text-gray-500 mt-1">View individual student exam results</p>
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
          <input type="text" placeholder="Search by student name or admission number..." className="pl-10 pr-4 py-2 w-full border rounded-lg" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <Award className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-500">Search for a student to view their exam results</p>
      </div>
    </div>
  );
};

export default ExamResult;